import React from "react"

import { LoadingSpinner } from "#components/loadingSpinner/loadingSpinner"
import { twMerge } from "#lib/twMergeConfig"

// TODO add horizontal and vertical variations
export function MessageLoadingSpinner({ className, message }: { className?: string; message?: string }) {
  message ??= "Laden..."

  return (
    <div className={twMerge("flex flex-col items-center justify-center gap-y-3 text-[12px] font-medium text-black", className)}>
      <LoadingSpinner className={"h-12 w-12"} />
      {message}
    </div>
  )
}
